import { Skeleton, CircularProgress} from '@mui/material';
import { useTranslation } from 'react-i18next';

function GenList({max}) {
  const list = [];
  const chunks = Math.floor(Math.random() * (10 - 2)) + 3;

  function getChunks(depth, length, itr) {
    if (list.length > max) return false;
    let width = `${Math.floor(Math.random() * (300 - 95)) + 79}px`
    list.push(<Skeleton key={`${depth}-${itr}-${Math.floor(Math.random() * 2096828) + Math.floor(Math.random() * 32)}`} className='skeleton-line' style={{width: width, marginLeft: `${depth*28}px`}}/>)
    const c = Math.random() > 0.4 ? Math.floor(Math.random() * 10) : 0;

    for (let i = 0; i < length; i++) {
      if (depth < 4) getChunks(depth + 1, c - depth >= 0 ? c - depth : 0, i);
    }
  }
  
  for (let i = 0; i < chunks; i++) {
    const c = Math.floor(Math.random() * 6) + 1;
    getChunks(0, c, i)
  }

  return (<>{list}</>)
}

const placeholder = <GenList max={90}/>

export default function TreeLoading() {
  const { t } = useTranslation();
  return (
    <div className='padding-8 height-100-tab'>
      <div className='loading-overlay'>
        <div className='flex-column align-center'>
          <div className='padding-left-4 padding-bottom-8'>{t("LOADING_IND")}</div>
          <CircularProgress color="primary" />
        </div>
      </div>
      <div className='padding-8 overflow-hidden height-100-100 blurred tree-skeleton'>
        {placeholder}
      </div>
    </div>
  );
}